// Layer attribute expression interfaces

import { TVectorLayerAttributeType } from "../../../Layers/LayerInterfaces";


export interface ILayerAttribExpression
{
  clauses: ILayerAttribExpressionClause[];
  operator: TLayerAttribExpressionOperator;
}

export type TLayerAttribExpressionOperator = "and" | "or";

//export type TLayerAttribType = 'text' | 'number'; // | 'date';  // Start simple for now, will add more types latest as needed

export interface ILayerAttribExpressionClause
{
  id: number;  // internal id used as a react key
  attribute_id?: number;
  type?: TVectorLayerAttributeType;
  operator: TLayerAttribExpressionStringOperator | TLayerAttribExpressionNumberOperator;
  value?: string;
  value_max?: string; // NOTE: it's a string so the user can freely type floats (with - and . chars) without validation interfering
}

export const LayerAttribExpressionStringOperators = 
[
  "is equal to", 
  "is not equal to",
  "begins with",
  "does not begin with",
  "ends with",
  "does not end with",
  "contains",
  "does not contain",
  "is empty",
  "is not empty"
] as const;
export type TLayerAttribExpressionStringOperator = typeof LayerAttribExpressionStringOperators[number];

export const LayerAttribExpressionNumberOperators = 
[
  "is equal to", 
  "is not equal to",
  "is less than",
  "is less than or equal to",
  "is greater than",
  "is greater than or equal to",
  "is in range",
  "is not in range",
  "is empty",
  "is not empty"
] as const;
export type TLayerAttribExpressionNumberOperator = typeof LayerAttribExpressionNumberOperators[number];
